import React, { useState } from 'react';
import '../css/Main.css';
import InstagramImg from '../resources/instagram.png';
import MailImg from '../resources/mail.png';
import HoverImage from './HoverImage';


function Contact() {

    return (
        <div>
            <div style={{ position: 'relative', textAlign: 'center', marginTop: '25px' }}>
                <hr style={{ border: 'none', borderTop: '1px solid black', margin: '20px 0' }} />
                <span
                    style={{
                        position: 'absolute',
                        top: '-10px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: 'white',
                    }}
                >
                </span>
            </div>
            <div style={styles.contactContainer}>
                <a href="https://www.instagram.com/hepkarlii/" target='_blank'>
                    <img src={InstagramImg} style={styles.contactLogo} ></img>
                </a>
                <a href="mailto:hepkarlii@gmail.com" target='_blank'>
                    <img src={MailImg} style={styles.contactLogo}></img>
                </a>
            </div>
        </div>
    );
}

const styles = {
    contactLogo: {
        width: '50px',
        height: 'auto'
    },
    contactContainer: {
        display: 'flex',
        justifyContent: 'center', // Yatayda ortala
        alignItems: 'center', // Dikeyde ortala
        height: '10vh', // Sayfa yüksekliğini %100 yap
        backgroundColor: '#0000', // Sayfa arka plan rengi
        gap: '25px',
        marginTop : '30px'
    },
}

export default Contact;